const VISITOR_KEY = 'yubu_visitor_id';
const SESSION_KEY = 'yubu_session_id';

function createUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function getStorage(type) {
  if (typeof window === 'undefined') return null;
  return type === 'local' ? window.localStorage : window.sessionStorage;
}

export function getVisitorId() {
  try {
    const storage = getStorage('local');
    if (!storage) return null;

    let visitorId = storage.getItem(VISITOR_KEY);
    if (!visitorId) {
      visitorId = createUuid();
      storage.setItem(VISITOR_KEY, visitorId);
    }
    return visitorId;
  } catch {
    return null;
  }
}

export function getSessionId() {
  try {
    const storage = getStorage('session');
    if (!storage) return null;

    let sessionId = storage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = createUuid();
      storage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return null;
  }
}
